import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSync } from "@fortawesome/free-solid-svg-icons"
import { generalStyles as gs } from "../styles/styles"
import InputV2 from "../basics/input/InputV2"
import FilteredSelectV2 from "../basics/input/FilteredSelectV2"
import { fetchVehModeles } from "../../store/actions/autreActions"
import { DEPANNAGE_TYPE_APPEL_POLICE } from "../../utilities/Addons"
import CollapsibleCardV2 from "../basics/interface/CollapsibleCardV2"

const SyncBox = () => (
	<div style={{ ...gs.inputReadonly, textAlign: "center" }}>
		<FontAwesomeIcon icon={faSync} spin />
	</div>
)

/**
 * Carte « Véhicule » : marque / modèle (FilteredSelectV2 chaînés, saisie libre
 * conservée) + plaques + châssis. Le matricule vit dans la carte Intervention
 * (affiché seulement pour un appel police). `carteGriseSlot` : vignettes de la
 * photo de carte grise (rendues par DepFicheV2, qui possède le viewer) — la
 * pièce d'identité du véhicule vit ici, pas dans la carte Fichiers.
 */
const DepFicheVehiculeV2 = ({
	dep,
	marques,
	fetchMarquesState,
	modeles,
	fetchModelesState,
	updateDep,
	refs,
	open,
	onToggle,
	carteGriseSlot = null,
}) => {
	const dispatch = useDispatch()
	const [marqueId, setMarqueId] = useState(null)
	// Le châssis n'est pertinent que pour un appel police (identification véhicule).
	const isPolice = dep.appel_type === DEPANNAGE_TYPE_APPEL_POLICE

	const onMarqueChange = (texte) => {
		updateDep("marque", texte)
		const m = marques.find((ma) => ma.nom === texte)
		if (m) {
			setMarqueId(m.id)
			dispatch(fetchVehModeles(m.id))
		} else if (marqueId) {
			setMarqueId(null)
			dispatch(fetchVehModeles(0))
		}
	}
	const onMarqueSelect = (marque) => {
		if (!marque) return
		updateDep("marque", marque.nom)
		setMarqueId(marque.id)
		dispatch(fetchVehModeles(marque.id)).then(() => updateDep("modele", ""))
	}

	return (
		<CollapsibleCardV2 title="Véhicule" open={open} onToggle={onToggle}>
			<div style={gs.fieldGroup}>
				<div style={gs.fieldRow}>
					<label style={gs.label}>Marque</label>
					{fetchMarquesState.loading ? (
						<SyncBox />
					) : (
						<FilteredSelectV2
							options={marques || []}
							defaultKey="nom"
							optionKeys="nom"
							value={dep.marque}
							onChange={onMarqueChange}
							onSelect={onMarqueSelect}
							inputRef={refs.refMarque}
							nextRef={refs.refModele}
							placeholder=""
						/>
					)}
				</div>
				<div style={gs.fieldRow}>
					<label style={gs.label}>Modèle</label>
					{fetchModelesState.loading ? (
						<SyncBox />
					) : (
						<FilteredSelectV2
							options={marqueId ? modeles || [] : []}
							defaultKey="nom"
							optionKeys="nom"
							value={dep.modele}
							onChange={(texte) => updateDep("modele", texte)}
							onSelect={(m) => m && updateDep("modele", m.nom)}
							inputRef={refs.refModele}
							nextRef={refs.refPlaques}
							placeholder=""
						/>
					)}
				</div>
				<div style={gs.fieldRow}>
					<label style={gs.label}>Plaques</label>
					<InputV2
						style={gs.input}
						value={dep.plaques}
						ref={refs.refPlaques}
						onFocus={(e) => e.target.select()}
						onChange={(e) => updateDep("plaques", e)}
						nextRef={isPolice ? refs.refChassis : refs.refMarque}
					/>
				</div>
				{isPolice && (
					<div style={gs.fieldRow}>
						<label style={gs.label}>Châssis</label>
						<InputV2
							style={gs.input}
							value={dep.chassis}
							ref={refs.refChassis}
							onFocus={(e) => e.target.select()}
							onChange={(e) => updateDep("chassis", e)}
							nextRef={refs.refMarque}
						/>
					</div>
				)}
				{carteGriseSlot ? (
					<div style={{ marginTop: 4 }}>{carteGriseSlot}</div>
				) : null}
			</div>
		</CollapsibleCardV2>
	)
}

export default DepFicheVehiculeV2
